import { observer } from 'mobx-react-lite'
import { Box } from 'shared/ui'
import { MessageField, type MessageFieldStore } from 'widgets/MessageField'
import { AgentSwitchField } from 'pages/chatbot/ui/AgentSwitchField/AgentSwitchField'
import type { AutoControlStore } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/store/autoControlStore'

type IAutoContentActionProps = {
  control: AutoControlStore
  contentStore: MessageFieldStore
  title: string
  questionInfoTooltip: string
}

export const AutoContentAction = observer(
  ({ control, contentStore, title, questionInfoTooltip }: IAutoContentActionProps) => (
    <Box display={'flex'} flexDirection={'column'} gap={2}>
      <AgentSwitchField
        title={title}
        active={control.isAuto}
        onChange={control.setIsAuto}
        questionInfoTooltipProps={{ label: questionInfoTooltip, width: 210 }}
      />
      {!control.isAuto && <MessageField messageFieldStore={contentStore} />}
    </Box>
  )
)
